/* src/app/_shared/components/avatar/avatar.component.scss */
:host {
  --width: 50px;
  --height: 50px;
}
.avatar-container {
  width: var(--width);
  height: var(--height);
  background-size: cover;
  background-position: center;
  border-radius: 50%;
}
/*# sourceMappingURL=avatar.component-ZGUVJMYR.css.map */
